export enum AdvisorMenuId {
    Dashboard = 0,
    ServiceRequest = 1,

    Accounts = 100,
    AccountsPositions = 101,
    AccountsBalances = 102,
    AccountsGroups = 103,
    AccountsActivity = 104,
    AccountsAllocationHistory = 105,
    AccountsTransferHistory = 106,
    AccountsRegister = 107,

    Models = 200,
    ModelsCreateModel = 201,
    ModelsManageModels = 202,
    ModelsModelMarketplace = 203,
    ModelsDriftReport = 204,

    Trading = 300,
    TradingAccountOrModel = 301,
    TradingEquity = 310,
    TradingAllocation = 302,
    TradingPreAllocation = 304,
    TradingTradeBlotter = 303,
    TradingPreIpoMarketplace = 306,
    TradingPostAllocation = 307,
    TradingBasket = 308,

    Transfers = 400,
    TransfersMoney = 401,
    TransfersBankLinks = 402,
    TransfersAcats = 403,

    Clients = 500,
    ClientsAllClients = 501,
    ClientsAddNewClient = 502,

    Insights = 600,
    InsightsHome = 601,
    InsightsSectors = 602,
    InsightsIpoCenter = 603,
    InsightsOptionRadar = 604,
    InsightsStockResearch = 605,
    InsightsStockList = 606,
    InsightsStockWall = 607,
    InsightsAdr = 608,
    InsightsWorldMarkets = 609,
    InsightsAnalysts = 610,
    InsightsEtfCenter = 611,
    InsightsEarnings = 612,
    InsightsReports = 613,
    InsightsScreener = 614,
    InsightsAnalystRatings = 615,

    Tools = 700,
    ToolsAlphaTools = 701,
    ToolsOnboarding = 702,

    Documents = 800,
    DocumentsStatements = 801,
    DocumentsConfirmations = 802,
    DocumentsTaxDocuments = 803,

    Settings = 900,
    SettingsAdvisors = 901,
    SettingsFirmSetup = 902,
    SettingsYourProfile = 903,
    SettingsPlatformSettings = 904,

    Reports = 1100,
    ReportsAUMByAccount = 1101,
    ReportsAccountActivity = 1102,
    ReportsAccountHistory = 1103,
    ReportsAUMByAsset = 1104,
    ReportsPositionsByAccount = 1105,
    ReportsTradeBlotter = 1106,
    ReportsTransactionFees = 1107,
    ReportsAdvisoryFees = 1108,
    ReportsBalanceSummaryReport = 1109,
    ReportsClientList = 1110,
    Support = 1200,
    ContactSupport = 1201,
    FormLibrary = 1202,

    // Components
    Components = 1300,
    ComponentsTable = 1301,
}

export enum ClientMenuId {
    Dashboard = 0,
    Position = 1,
    Activity = 2,
    AccountDocuments = 3,
    ClientDocuments = 4,

    Account = 100,
    AccountSummary = 101,
    AccountHistory = 102,

    Transfers = 200,
    TransfersAcats = 201,
    TransfersMoney = 202,
    TransfersBankLinks = 203,

    Settings = 300,
    SettingsProfile = 301,
    SettingsPlatformSettings = 302,
}

export enum DetailsTabId {
    Model = 1001,
    Group = 1002,
    User = 1003,
    Account = 1004,
    Quote = 1005,
    NewsArticle = 1006,
}

export enum DashboardSummaryTableId {
    OptionsInTheMoney = 'optionsInTheMoney',
    OptionsExpiringSoon = 'optionsExpiringSoon',
    MoneyMovements = 'moneyMovements',
}

export enum DashboardVisualizationCardTableId {
    UnallocatedTrades = 'unallocatedTrades',
}

export enum SectorMainSectionId {
    SectorCards = 'sector-cards',
    MarketOverviewCards = 'marketOverview-cards',
}

export type SubSettingId = SectorMainSectionId | DashboardMainSectionId | PositionsSectionId;

export enum DashboardMainSectionId {
    SummaryCards = 'summary-cards',
    VisualizationCards = 'visualization-cards',
    News = 'news',
}

export enum SideBarComponentId {
    MarketClock = 'market-clock',
    ComponentContainer = 'component-container',
}

export enum TablePersistKey {
    TableActivity = 'TableActivity',
    TableAccounts = 'TableAccounts',
    TableWatchlist = 'TableWatchlist',
    TableOrders = 'TableOrders',
    TablePortfolio = 'TablePortfolio',
    TablePositions = 'TablePositions',
    TableAccountActivity = 'TableAccountActivity',
    TableDriftReport = 'TableDriftReport',
    TablePositionsMissingFromTheModel = 'TablePositionsMissingFromTheModel',
    TablePositionsNotInModel = 'TablePositionsNotInModel',
    TableOptionChain = 'TableOptionChain',
    TableAdjustmentPreview = 'TableAdjustmentPreview',
    TableStockScreener = 'TableStockScreener',
    TableFundScreener = 'TableFundScreener',
    TableBondScreener = 'TableBondScreener',
}

export enum DashboardChartId {
    AccountTypes = 'accountTypes',
    AccountSizes = 'accountSizes',
    TopPositions = 'topPositions',
    Sectors = 'sectors',
    MarketCap = 'marketCap',
    UnallocatedTrades = 'unallocatedTrades',
}

export enum TopPositionsChartId {
    TopPositions = 'topPositions',
    SectorBreakdown = 'sectorBreakdown',
    MarketCap = 'marketCap',
}

export enum MarketOverviewTableId {
    Earnings = 'earnings',
    TopETF = 'topEtf',
    MostActive = 'mostActive',
}

export enum SectorSettingsTableId {
    Sectors = 'sectors',
    TopCompanyChart = 'topCompanyChart',
    TopCompanies = 'topCompanies',
    TopEtfs = 'topEtfs',
}

export enum PositionsSectionId {
    BranchInfo = 'branch-info',
    TopPositionsInfo = 'top-positions-info',
    PositionsTable = 'positons-table',
}

export enum SideBarTabId {
    Heatmap = 'Heatmap',
    Orders = 'Orders',
    Portfolio = 'Portfolio',
    Watchlist = 'Watchlist',
    Help = 'Help',
}

export enum ProfileTabId {
    General,
    Notifications,
    Security,
}

export enum ModelTabId {
    Accounts,
    Positions,
    Activity,
    DriftReport,
    Edit,
}

export enum GroupTabId {
    Accounts,
    Positions,
    Edit,
}

export enum ScreenerTabId {
    BondScreener,
    EtfScreener,
    MutualFundScreener,
    StockScreener,
}

export enum UserTabId {
    Summary,
    Accounts,
    Positions,
    Orders,
    ModelsAndGroups,
    CorporateActions,
    Profile,
    ContactSupport,
}

export enum AccountTabId {
    Summary = 'summary',
    AccountInfo = 'accountInfo',
    Positions = 'positions',
    Activity = 'activity',
    DriftReport = 'driftReport',
    Money = 'money',
    BankLinks = 'bankLinks',
    AccountDocuments = 'accountDocuments',
    ModelsAndGroups = 'modelsAndGroups',
    CorporateActions = 'corporateActions',
    RaiseMoney = 'raiseMoney',
    History = 'history',
    Profile = 'profile',
    Acats = 'acats',
    Charges = 'charges',
}

export enum QuoteTabId {
    Overview = 'overview',
    Profile = 'profile',
    Chart = 'chart',
    OptionChain = 'optionChain',
    Positions = 'positions',
    Orders = 'orders',
    Acats = 'acats',
    CorporateActions = 'corporateActions',
    News = 'news',
    Analysts = 'analysts',
}

export enum AllocationTabId {
    Selection,
    Details,
    Confirmation,
}

export enum TradingTabId {
    Details,
    Preview,
    Confirmation,
}

export enum DocumentsTabId {
    Documents,
}

export enum RaiseMoneyTabId {
    Positions,
    Preview,
    Confirmation,
}

export enum AnalystRatingMainFilter {
    TrendingStocks = 'Trending',
    DailyRecommendations = 'Daily',
}

export enum AnalystRatingSortFilter {
    TopAnalysts,
}

export enum TaxLotDialogDropdownIds {
    Allocation = 'allocation',
    Trading = 'trading',
}

export enum SavedOrdersOptions {
    MyOrders = 'MySavedOrders',
    AllOrders = 'AllSavedOrders',
}

export enum EtfCenterFilterTarget {
    FilterMain = 'filterMain',
    FilterInverse = 'filterInverse',
    FilterLeverage = 'filterLeverage',
    FilterCategory = 'filterCategory',
    FilterAsset = 'filterAsset',
    FilterSponsor = 'filterSponsor',
}
